{
    "VITE_AZURE_REDIRECT_URI": "HELM_AZURE_REDIRECT_URI",
    "VITE_API_BASE": "HELM_API_BASE",
    "VITE_AUTH_ENTRA_AZURE_TENANT_ID": "HELM_AUTH_ENTRA_TENANT_ID",
    "VITE_AUTH_ENTRA_AZURE_CLIENT_ID": "HELM_AUTH_ENTRA_CLIENT_ID",
    "VITE_AUTH_ENTRA_AUTHORITY_SCOPE": "HELM_AUTH_ENTRA_SCOPE",
    "VITE_AUTH_ENTRA_AUTHORITY_DOMAIN": "HELM_AUTH_ENTRA_AUTHORITY",
    "VITE_SENTRY_DSN": "HELM_SENTRY_DSN"
}
